import * as React from "react"

export default function OtherVehicleIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 2.254a7.746 7.746 0 110 15.492 7.746 7.746 0 010-15.492zm0 .75a6.996 6.996 0 100 13.992 6.996 6.996 0 000-13.992zm0 .995a6.001 6.001 0 110 12.003 6.001 6.001 0 010-12.003zm-.592 11.218a5.304 5.304 0 001.183 0l.213-2.516a2.817 2.817 0 01-1.609 0l.213 2.516zm3.091-3.914c-.215.412-.53.764-.911 1.025l-.232 2.745a5.256 5.256 0 003.807-4.122l-2.664.352zm-7.663-.352a5.256 5.256 0 003.808 4.122l-.233-2.745a2.83 2.83 0 01-.911-1.025l-2.664-.352zM10 7.931a2.07 2.07 0 101.894 2.9 2.06 2.06 0 00.176-.83A2.07 2.07 0 0010 7.93zm0 .572a1.497 1.497 0 110 2.994 1.497 1.497 0 010-2.994zm0 .75a.747.747 0 100 1.494.747.747 0 000-1.494zm-5.16-.225a5.278 5.278 0 00-.087 1.157l2.476.325a2.806 2.806 0 01.26-1.79l-2.65.308zm7.67-.308a2.806 2.806 0 01.26 1.79l2.476-.325c.002-.062.005-.123.005-.185 0-.332-.033-.657-.092-.972l-2.65-.308zM10 4.749a5.253 5.253 0 00-4.951 3.5l3.083-.357a2.806 2.806 0 013.735 0l3.083.357a5.252 5.252 0 00-4.95-3.5z"
        fill={props.fill}
      />
    </svg>)
}
